<!--
 * @FileDescription: 库位选择模板（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="location"  v-clickoutside:[classList]="closeIconBlock" v-if="isShow">
      <div class="location-top">
          <template v-if="locationListAll.length > 0">
              <div class="location-item div-overflow">
                  <div class="location-item-li"
                       :class='[item.isCheck ? "location-item-li-active" : " " , item.isCheck1 ? "location-cir":""]'
                       v-for="(item,index) in locationListAll"
                       :key="index"
                       @click.stop="onSelectCheck(1,item,index)">{{item.name}}</div>
              </div>
              <div class="location-item div-overflow">
                  <div class="location-item-li"
                       :class='[item.isCheck ? "location-item-li-active" : " " , item.isCheck1 ? "location-cir":""]'
                       v-for="(item,index) in locationListAll1"
                       :key="index"
                       @click.stop="onSelectCheck(2,item,index)">{{item.name}}</div>
              </div>
              <div class="location-item div-overflow">
                  <div class="location-item-li"
                       :class="item.isCheck ? 'location-item-li-active':''"
                       v-for="(item,index) in locationListAll2"
                       :key="index">
                      <a-checkbox :checked="item.isCheck" @click.stop="onSelectCheck(3,item,index)">{{item.name}}</a-checkbox>
                  </div>
              </div>
          </template>
          <template v-else>
              <div class="location-top-title">暂未设置库位，去仓库管理里设置库位吧~</div>
          </template>
      </div>
      <div class="location-footer">
          <a-button class="location-footer-cancel" @click.stop="onBtn(1)">取消</a-button>
          <a-button class="location-footer-cancel btn-save-next" @click.stop="onBtn(2)">确认</a-button>
      </div>
  </div>
</template>
<script>
import {getPageAccount,locationAllList} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
export default {
    mixins:[mixins],
    props:{
    },
    data(){
        return{
            isShow:false,
            selectIndex:0,
            selectIndex1:0,
            selectObj:[],
            selectId:[],
            selectObj1:[],
            selectId1:[],
            storageId:'',
            locationListAll1:[],
            locationListAll2:[],
            classList:[],
            recordItem:{},
            locationListAll:[],
            num:0
        }
    },
    watch: {

    },
    mounted () {
    },
    created () {

    },
    components: {

    },
    methods: {
        closeIconBlock(){
            this.isShow = false
            this.$emit('onCancelLocation',this.recordItem)
        },
        /**
        * @description: 此为方法注释（方法描述）
        */
        onOpen(record,id){
            this.recordItem = record
            this.storageId = id
            if(this.num == 0){
                this.getLocation()
            }
            this.num += 1;
        },
        getLocation(){
            let data = {storageId:this.storageId,companyStoreId:this.$store.state.shopId,}
            data = this.$qs.stringify(data)
            let result = []
            if(!this.isEmpty(this.recordItem.locationIdStr)){
                let resultObj = this.recordItem.locationIdStr.split(',').filter(function (s) {return s && s.trim(); })
                this.selectId = resultObj
                this.selectObj = this.recordItem.locationName.split(',').filter(function (s) {return s && s.trim(); })
                this.selectObj1 =[]
                this.selectId1 = []
                this.recordItem.locationName.split(',').filter(function (s) {return s && s.trim(); }).map((item)=>{return item = item.split('-')}).forEach((seob)=>{
                    this.selectObj1.push(seob[2])
                })
                this.recordItem.locationIdStr.split(',').filter(function (s) {return s && s.trim(); }).map((item)=>{return item = item.split('-')}).forEach((seob)=>{
                    this.selectId1.push(seob[2])
                })
                let resultObj1 =resultObj.map((item)=>{
                    return item = item.split('-')
                })
                result = resultObj1
            }
            locationAllList(data,{}).then((res)=>{
                if(res.success){
                    res.result.forEach((item)=>{
                        item.isCheck = false
                        item.isCheck1 = false
                        if(result.length != 0){
                            result.forEach((obj1)=>{
                                item.id == obj1[0] ? item.isCheck1 = true : ''
                            })
                        }
                        if(item.childLocation.length > 0){
                            item.childLocation.forEach((item1)=>{
                                item1.isCheck = false
                                item1.isCheck1 = false
                                if(result.length != 0){
                                    result.forEach((obj1)=>{
                                        item1.id == obj1[1] ? item1.isCheck1 = true : ''
                                    })
                                }
                                if(item1.childLocation.length > 0){
                                    item1.childLocation.forEach((item2)=>{
                                        item2.isCheck = false
                                        item2.isCheck1= false
                                        if(result.length != 0){
                                            result.forEach((obj1)=>{
                                                item2.id == obj1[2] ? item2.isCheck = true : ''
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    })
                    this.locationListAll = res.result
                    this.$nextTick(()=>{
                        this.isShow = true
                    })
                }
            })
        },
        /**
         * @description: 选中（方法描述）
         */
        onSelectCheck(tabIndex,item,index){
            if(tabIndex == 1){
                this.locationListAll.forEach((item)=>{
                    item.isCheck = false
                })
                item.isCheck = !item.isCheck
                this.locationListAll1 = this.locationListAll[index].childLocation
                this.locationListAll2 = []
                this.selectIndex = index
            }else if(tabIndex == 2){
                this.locationListAll1.forEach((item)=>{
                    item.isCheck = false
                })
                item.isCheck = !item.isCheck
                this.selectIndex1 = index
                this.locationListAll2 = this.locationListAll1[index].childLocation
            }else if(tabIndex == 3){
                item.isCheck = !item.isCheck
                if(item.isCheck){
                    let result = this.locationListAll[this.selectIndex].name + '-'+this.locationListAll1[this.selectIndex1].name + '-'+item.name
                    let result1 = this.locationListAll[this.selectIndex].id + '-'+this.locationListAll1[this.selectIndex1].id + '-'+item.id
                    if( this.selectObj.indexOf(result) < 0){
                        this.selectObj.push(result)
                        this.selectId.push(result1)
                        this.selectObj1.push(item.name)
                        this.selectId1.push(item.id)
                    }
                }else{
                    let result = this.locationListAll[this.selectIndex].name + '-'+this.locationListAll1[this.selectIndex1].name + '-'+item.name
                    let result1 = this.locationListAll[this.selectIndex].id + '-'+this.locationListAll1[this.selectIndex1].id + '-'+item.id
                    let i = this.selectObj.indexOf(result)
                    if(this.selectObj.indexOf(result) >= 0){
                        this.selectObj.splice(i,1)
                        this.selectId.splice(i,1)
                        this.selectObj1.splice(i,1)
                        this.selectId1.splice(i,1)
                    }
                }
                let i = 0
                this.locationListAll1[this.selectIndex1].childLocation.forEach((item1)=>{
                    if(item1.isCheck){
                        i++
                    }
                })
                if(i>0){
                    this.locationListAll[this.selectIndex].isCheck1 = true
                    this.locationListAll1[this.selectIndex1].isCheck1 = true
                }else{
                    this.locationListAll[this.selectIndex].isCheck1 = false
                    this.locationListAll1[this.selectIndex1].isCheck1 = false
                }
            }
        },
        /**
         * @description: 取消和确认（方法描述）
         */
        onBtn(index){
            this.isShow = false
            if(index == 2){
                this.$emit('onBtn',index,this.selectObj,this.selectId,this.selectObj1,this.selectId1)
            }else{
                this.$emit('onBtn',index)
            }

        },
    },

}
</script>
<style scoped lang="scss">
.location{
    position: absolute;
    top: 40px;
    left: 0;
    width: 343px;
    height: 246px;
    background-color: #fff;
    z-index: 100;
    box-shadow:0px 1px 14px 0px rgba(1,85,255,0.16);
    .location-top{
        height: 195px;
        overflow: hidden;
        display: flex;
        .location-top-title{
            height: 100%;
            width: 100%;
            line-height: 195px;
            text-align: center;
        }
        .location-item{
            height: 195px;
            overflow: auto;
            width: 114px;
            border-right: 1px solid #DDDDDD;
            padding: 4px 0;
            .location-item-li{
                padding-left: 16px;
                height: 36px;
                line-height: 36px;
                color: #555555;
                cursor: pointer;
                position: relative;
            }
            .location-item-li-active{
                background:rgba(55,122,252,0.1);
            }
            .location-cir:after{
                content: '';
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 8px;
                width: 4px;
                height: 4px;
                background-color: #FF0000;
                border-radius: 50%;
            }
        }
        .location-item:last-child{
            border-right: 1px solid transparent;
        }
    }
    .location-footer{
        height: 50px;
        border-top: 1px solid #DDDDDD;
        display: flex;
        align-items: center;
        justify-content: center;
        .location-footer-cancel{
            width: 80px;
            height: 34px;
        }
        .btn-save-next{
            margin-left: 15px;
        }
    }

}
</style>
